import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import * as constants from "../const";
import DateTime from 'react-datetime';
import moment from "moment";
import {filterAction, resetFilterAction} from "../actions/index";
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import Modal from 'react-modal';

let inputProps = {
    readOnly: false, 
	maxLength: 10, 
	placeholder: 'MM/DD/YYYY'
};

class Filters extends React.Component{
    constructor(props) {
        super(props);
        let filterObj = { // default filter object
            trainNum:'',
            division:'NA',
            employeeId:'',
            employeeFirstName:'',
            employeeLastName:'',
            jobClass:'NA',
            jobType:0,
            workdayDateFrom: '',
            workdayDateTo: '',
            outlaw:false,
            byFilter:false,
            showFilter:false,
            fromLocation:'-',
            toLocation:'-',
            fromTime:'',
            toTime:'',
            fromTimeCondition:'0',
            toTimeCondition:'0',
            showNonRegisteredEmp:false,
            auditFromDate:'',
            auditToDate:'',
            originalInserts:false,
            operationType:'',
            tableType:'',
            fieldType:'',
            fieldValues:[],
            deadheadType : '',
            activityName : '',
            excludeOFFDays:true,
            excludeNonCertified:true
        }
        this.defaultState = filterObj;
        this.state  =  filterObj;
    }

    // called after component renderd
    componentDidMount() {
        let self = this;
        this.setState(
            self.defaultState
        );
        Modal.setAppElement(this.el);
    }

    // close modal when click outside
    handleClickOutside(event) {
        let div = this.refs.filterDiv;
        if (this.state.showFilter && !ReactDOM.findDOMNode(div).contains(event.target)) {
            this.toggleFilter();
        }
    }

    // toggle filter
    toggleFilter() {
        let showFilter = this.state.showFilter;
        this.setState({
            showFilter: !showFilter
        });
        if(showFilter == true){
            document.body.style.overflow = "auto";
        } else {
            document.body.style.overflow = "hidden";
        }
    }

    // table dropdown selection change
    handleTableChange(e, data){
        const { name, value } = e.target;
        this.setState({ [name]: value });
        let fieldValues = [];
        this.setState(
            { [name]: value },
            () => {
                    if(data == 'table'){
                        if(this.state.tableType == 'W'){
                            fieldValues = [{
                                    key:'wdy_certify_status',
                                    value:'Workday Certify Status'
                                },
                                {
                                    key:'wdy_comments',
                                    value:'Workday Comments'
                                },{
                                    key:'wdy_certify_date',
                                    value:'Workday Certify Date'
                                },
                                {
                                    key:'wdy_claim_date',
                                    value:'Workday Claim Date'
                                }];
                        } else if(this.state.tableType == 'D'){
                            fieldValues = [{
                                key:'dty_act_name',
                                value:'Duty Activity Name'
                            }, {
                                key:'dty_act_start_time',
                                value:'Duty Activity Start Time'
                            }, {
                                key:'dty_act_end_time',
                                value:'Duty Activity End Time'
                            }];
                        } else {
                            fieldValues = [];
                        }
                        this.setState({
                            fieldValues :fieldValues
                        });
                    }
                    this.setState({
                        fieldType:''
                    })  
                }
          );
        
        
    }
    handleOnChange(e,data) { // setting state values when field values are changing
        const { name, value } = e.target;
        this.setState({ [name]: value });
        if(data == 'table'){
            this.setState({
                fieldValues :[{
                    key:'dty_act_name',
                    value:'Duty Activity Name'
                }]
            });
        }
    }
    
    // changing Date in DatePicker
    changeDate(date, dateSelection){



        if(dateSelection == 'fromTime' || dateSelection == 'toTime'){
            var selectedDate = moment(date, 'HH:mm')
            selectedDate = selectedDate.format('HH:mm');
            selectedDate = selectedDate.split(':')[0] + 'h' + selectedDate.split(':')[1];
            let self = this;
            setTimeout(function() {
                if(dateSelection == 'fromTime'){
                    self.setState({
                        fromTime:selectedDate
                    })  
                } else {
                    self.setState({
                        toTime:selectedDate
                    })  
                }  
            },1000);
        } 
        else if(dateSelection == 'start'){
            if ((date.length == 2 || date.length == 5) && date.length != undefined ){
                date += '/';
                this.setState({
                    workdayDateFrom: date
                })           
           /* 
            }  else if(this.state.workdayDateFrom.length == 10) {
                var selectedDate = moment(this.state.workdayDateFrom);
                selectedDate = selectedDate.format('MM/DD/YYYY');
                this.setState({
                    workdayDateFrom: selectedDate
                })
                */
            } else {
                if(date.length == undefined){
                    var selectedDate = moment(date);
                    selectedDate = selectedDate.format('MM/DD/YYYY');
                    this.setState({
                        workdayDateFrom: selectedDate
                    })
                }
            }         
        } 
        else if(dateSelection == 'auditFromDate'){
            
            if (date.length == 2 || date.length == 5 ){
                date += '/';
                this.setState({
                    auditFromDate: date
                })
            } else if(this.state.auditFromDate.length == 10) {
                var selectedDate = moment(this.state.auditFromDate);
                selectedDate = selectedDate.format('MM/DD/YYYY');
                this.setState({
                    auditFromDate: selectedDate
                })
            }  else {
                if(date.length == undefined){
                    var selectedDate = moment(date);
                    selectedDate = selectedDate.format('MM/DD/YYYY');
                    this.setState({
                        auditFromDate: selectedDate
                    })
                }
            }       
        } 
        else if(dateSelection == 'auditToDate'){
            
            if (date.length == 2 || date.length == 5 ){
                date += '/';
                this.setState({
                    auditToDate: date
                })
            } else if(this.state.auditToDate.length == 10) {
                var selectedDate = moment(date);
                selectedDate = selectedDate.format('MM/DD/YYYY');
                this.setState({
                    auditToDate: selectedDate
                })
            }  else {
                if(date.length == undefined){
                    var selectedDate = moment(date);
                    selectedDate = selectedDate.format('MM/DD/YYYY');
                    this.setState({
                        auditToDate: selectedDate
                    })
                }
            }       
        }
        else {
            if ((date.length == 2 || date.length == 5) && date.length != undefined ){
                date += '/';
                this.setState({
                    workdayDateTo: date
                })
            /*} else if(this.state.workdayDateTo.length == 10) {
                var selectedDate = moment(this.state.workdayDateTo);
                selectedDate = selectedDate.format('MM/DD/YYYY');
                this.setState({
                    workdayDateTo: selectedDate
                })*/
            } else {
                if(date.length == undefined){
                    var selectedDate = moment(date);
                    selectedDate = selectedDate.format('MM/DD/YYYY');
                    this.setState({
                        workdayDateTo: selectedDate
                    })
                }
            }     
        }
    }

    //toggling checkboxes
    setFilter(e, event) {
        if(event == 'checkBox'){
            this.setState({
                outlaw:e.target.checked
            });
        } else if(event == "nonregisteredemp"){
            this.setState({
                showNonRegisteredEmp:e.target.checked
            });
        } else if(event == 'originalInserts'){
            this.setState({
                originalInserts:e.target.checked
            })
        } else  if(event == 'excludeOFFDays'){
            this.setState({
                excludeOFFDays:e.target.checked
            })
        }
        else  if(event == 'excludeNonCertified'){
            this.setState({
                excludeNonCertified:e.target.checked
            })
        } 
        
        else {
            const { name, value } = e.target;
            this.setState({ [name]: value });
        }
        
    };

    // submitting filter
    submitFilter(e, filterObj){
        let self = this;
        filterObj.byFilter = true;
        filterObj.byPagination = false;
        e.preventDefault();
        this.props.submitFilterAction(filterObj, function(filterObj){
            self.props.getData(e, filterObj);
        });
       this.toggleFilter();
    }

    // clearing filter
    clearFilter(){
        let self = this;
        let route = localStorage.getItem("route");
        this.setState(self.defaultState);
        this.props.resetFilter(self.defaultState);
        let filterObj = self.defaultState;
        filterObj.byFilter = route == constants.FRA_REPORT ? false : filterObj.byFilter;
        filterObj["isResetFRA"] = route == constants.FRA_REPORT ? true : false;
        filterObj.byPagination = false;
        this.props.submitFilterAction(filterObj, function(filterObj){
            self.props.getData(undefined, filterObj);
        });      
        this.toggleFilter();
    }

    // clearing date in DatePicker
    clearDate(e, prop){
        console.log('Clear date called')
        e.preventDefault();
        let self = this;
        if(prop == 'auditFromDate'){
            this.setState({
                auditFromDate:''
            })
        } else if(prop == 'auditToDate'){
            this.setState({
                auditToDate:''
            })
        } else if(prop == 'fromDate'){
            this.setState({
                workdayDateFrom:''
            })
        } else if(prop == 'toTime'){
            self.refs.toTime.state.inputValue = '';
            self.setState({
                toTime:''
            });
        } else if(prop == 'fromTime'){
            self.refs.fromTime.state.inputValue = '';
            self.setState({
                fromTime:''
            });
        } else {
            this.setState({
                workdayDateTo:''
            })
        }        
    }

    // render locations
    renderLocations(){
        const { locations } = this.props;
        if(locations && locations.length > 0){
            return locations.map(function(location, index){
                return <option key={index} value={location.loc_identifier}>{location.loc_description}</option>
            })
        } else if(locations && locations.length == 0){
            return <option disabled>No Records...</option>
        } else {
            return <option disabled>Loading...</option>
        }
    }

    renderActivities(){
        const { filteractivities } = this.props;
        if(filteractivities && filteractivities.length > 0){
            return filteractivities.map(function(activity, index){
                return <option key={index} value={activity.activity_type}>{activity.activity_name}</option>
            })
        } else if(filteractivities && filteractivities.length == 0){
            return <option disabled>No Records...</option>
        } else {
            return <option disabled>Loading...</option>
        }
    }

    // rendering fields
    renderFields(fields){
        if(fields && fields.length > 0){
            return fields.map(function(field, index){
                return <option key={index} value={field.key}>{field.value}</option>
            })
        } else if(fields && fields.length == 0){
            return <option disabled>No Fields...</option>
        } else {
            return <option disabled>Loading...</option>
        }
    }
    render() {
        let route = localStorage.getItem("route"),
            showOutlaw = route != constants.OUTLAW && route != constants.FRA_REPORT;
        let isHOS = route == constants.ADMIN_HOS_LOG;
        let isFRA = route == constants.FRA_REPORT
        let isSeries14 = route == constants.SERIES14
            const { locations } = this.props;

 
        if(this.state){
            let showFilter = this.state.showFilter;
            const { Component, Filter } = this.props;
            const { workdayDateFrom, workdayDateTo, showNonRegisteredEmp,originalInserts, searchText, outlaw, fromTimeCondition, 
                    toTimeCondition, fromTime, toTime, auditFromDate, auditToDate, operationType, tableType, fieldType, fieldValues,excludeOFFDays,excludeNonCertified} = this.state;
            var filterObj = this.state,
                today = moment(),
                validAuditFromDate = function( current ){
                    return current.isBefore( today );
                }, validAuditToDate;
            if(auditFromDate){
                validAuditToDate = function(current){
                    return current.isAfter(auditFromDate) || current.isSame(auditFromDate);
                }
            } else {
                validAuditToDate = function(current){
                    return true;
                }
            }
            var valid = function( current ){
                return current.isBefore( today );
            };
            var validToDate;
            if(workdayDateFrom){
                var fromDate = workdayDateFrom;
                validToDate = function(current){
                    return current.isAfter(fromDate) || current.isSame(fromDate);
                }
            } else {
                validToDate = function(current){
                    return true;
                }
            }
            return (
                <div ref={ref => this.el = ref}>
                <button type="button" className="btn btn-primary dropdown-toggle filterBtn" onClick={this.toggleFilter.bind(this)}>
                        Filter <span className="fa fa-filter"></span></button>
                <SlidingPane ariaHideApp={false}
                    className='filterPane'
                    overlayClassName='some-custom-overlay-class'
                    isOpen={ showFilter }
                    width='400px'
                    title='Choose options to filter'
                    onRequestClose={this.toggleFilter.bind(this)}>
                    <form className="form-horizontal filterForm" onSubmit={(e) => this.submitFilter(e, filterObj)} autoComplete="off">
                        <div className="filterContainer">
                                <div className="" role="group">
                                <div className={(showFilter ? "open" : "") + " dropdown dropdown-lg"} ref="filterDiv">                                   
                                    <div ref="filterDiv" className={route == constants.AUDIT_TRAIL ? '' : 'hidden'}>
                                        <div className={"form-group"}>
                                            <span className="filterLbl">Include Original Inserts</span>
                                            <input className="outlawChkBox" type="checkbox" name="originalInserts" checked={originalInserts} onChange={(e) => this.setFilter(e, 'originalInserts')}/>
                                        </div>
                                        <div className="form-group datePicker">
                                            <span className="filterLbl">Audit Date From</span>
                                            <span className="fa fa-close closeIcon" onClick={(e) => this.clearDate(e, 'auditFromDate')}></span>
                                            <DateTime  isValidDate={ validAuditFromDate } inputProps={inputProps} closeOnSelect timeFormat={false} value={auditFromDate} onChange={(e) => this.changeDate(e, 'auditFromDate')}/>
                                        </div>
                                        <div className="form-group datePicker">
                                            <span className="filterLbl">Audit Date To</span>
                                            <span className="fa fa-close closeIcon" onClick={(e) => this.clearDate(e, 'auditToDate')}></span>
                                            <DateTime isValidDate={ validAuditToDate } inputProps={inputProps} closeOnSelect timeFormat={false} value={auditToDate} onChange={(e) => this.changeDate(e, 'auditToDate')}/>
                                        </div>
                                        <div className="form-group">
                                            <span className="filterLbl">Table</span>
                                            <select className="form-control filterDD" name="tableType" value={this.state.tableType} onChange={(e) => this.handleTableChange(e, 'table')} >
                                                <option value="">Select Table</option>
                                                <option value="W">Workday</option>
                                                <option value="D">Duty Activity</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <span className="filterLbl">Field</span>
                                            <select className="form-control filterDD" name="fieldType" value={this.state.fieldType} onChange={this.handleOnChange.bind(this)} >
                                                <option value="">Select Field</option>
                                                {
                                                    this.renderFields(fieldValues)
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div ref="filterDiv" className={route != constants.AUDIT_TRAIL ? '' : 'hidden'}>
                                        <div className={"form-group datePicker " + (isFRA||isHOS ? "hidden" : "")} >
                                            <span className="filterLbl">Train Number</span>
                                            <input name='trainNum' className='form-control' value={this.state.trainNum} type='text' onChange={this.setFilter.bind(this)} />
                                        </div>
                                        <div className="form-group">
                                            <span className="filterLbl">Division</span>
                                            <select className="form-control filterDD" name="division" value={this.state.division} onChange={this.handleOnChange.bind(this)} >
                                                <option value="NA">Select Division</option>
                                                <option value="N-CAC">N-CAC</option>
                                                <option value="S-CAC">S-CAC</option>
                                                <option value="N-ENG">N-ENG</option>
                                                <option value="S-ENG">S-ENG</option>
                                            </select>
                                        </div>
                                        <div className={"form-group" + (isSeries14 ? " hidden" : "")}>
                                            <span className="filterLbl">Include Non Registered Employees</span>
                                            <input className="outlawChkBox" type="checkbox" name="showNonRegisteredEmp" checked={showNonRegisteredEmp} onChange={(e) => this.setFilter(e, 'nonregisteredemp')}/>
                                        </div>
                                        <div className={"form-group" + (isSeries14 ? " hidden" : "")}>
                                            <span className="filterLbl">Exclude OFF Days</span>
                                            <input className="outlawChkBox" type="checkbox" name="excludeOFFDays" checked={excludeOFFDays} onChange={(e) => this.setFilter(e, 'excludeOFFDays')}/>
                                        </div>
                                        <div className={"form-group" + (isSeries14 ||isHOS ? " hidden" : "")}>
                                            <span className="filterLbl">Exclude Non-Certified</span>
                                            <input className="outlawChkBox" type="checkbox" name="excludeNonCertified" checked={excludeNonCertified} onChange={(e) => this.setFilter(e, 'excludeNonCertified')}/>
                                        </div>
                                        <div className="form-group">
                                            <span className="filterLbl">Employee ID</span>
                                            <input name='employeeId' className='form-control' value={this.state.employeeId} type='text' onChange={this.setFilter.bind(this)} />
                                        </div>
                                        <div className="form-group">
                                            <span className="filterLbl">Employee First Name</span>
                                            <input name='employeeFirstName' className='form-control' value={this.state.employeeFirstName} type='text' onChange={this.setFilter.bind(this)} />
                                        </div>
                                        <div className="form-group">
                                            <span className="filterLbl">Employee Last Name</span>
                                            <input name='employeeLastName' className='form-control' value={this.state.employeeLastName} type='text' onChange={this.setFilter.bind(this)} />
                                        </div>
                                        <div className="form-group datePicker">
                                            <span className="filterLbl">Workday Date From</span>
                                            <span className="fa fa-close closeIcon" onClick={(e) => this.clearDate(e, 'fromDate')}></span>
                                            <DateTime  isValidDate={ valid } inputProps={ inputProps } closeOnSelect timeFormat={false} value={workdayDateFrom} onChange={(e) => this.changeDate(e, 'start')}/>
                                        </div>
                                        <div className="form-group datePicker">
                                            <span className="filterLbl">Workday Date To</span>
                                            <span className="fa fa-close closeIcon" onClick={(e) => this.clearDate(e, 'toDate')}></span>
                                            <DateTime isValidDate={ validToDate } inputProps={inputProps} closeOnSelect timeFormat={false} value={workdayDateTo} onChange={(e) => this.changeDate(e, 'end')}/>
                                        </div>  
                                        <div className={"form-group " + (showOutlaw && !isHOS && !isSeries14 ? 'show' : 'hidden')}>
                                            <span className="filterLbl">Outlaw</span>
                                            <input className="outlawChkBox" type="checkbox" name="outlaw" checked={outlaw} onChange={(e) => this.setFilter(e, 'outlaw')}/>
                                        </div>  
                                        <div className="form-group datePicker timePicker">
                                            <span className="filterLbl">Hours of Service</span>
                                            <span className="fa fa-close closeIcon" onClick={(e) => this.clearDate(e, 'fromTime')}></span>
                                            <div className="clear"></div>
                                            <div className="timeOption">
                                                <select className="form-control filterDD" value={fromTimeCondition} name="fromTimeCondition" onChange={this.handleOnChange.bind(this)} >
                                                    <option value="0">Equal to</option>
                                                    <option value="1">Greater than</option>
                                                    <option value="2">Less than</option>
                                                </select>
                                            </div>
                                            <DateTime ref="fromTime" closeOnSelect inputProps={{readOnly: true}} initialValue={fromTime} dateFormat={false} timeFormat="HH:mm" onChange={(e) => this.changeDate(e, 'fromTime')}/>
                                        </div>
                                        <div className={"form-group datePicker timePicker" + (isFRA || isHOS? " hidden" : "")}>
                                            <span className="filterLbl">Total Shift</span>
                                            <span className="fa fa-close closeIcon" onClick={(e) => this.clearDate(e, 'toTime')}></span>
                                            <div className="clear"></div>
                                            <div className="timeOption">
                                                <select className="form-control filterDD" value={toTimeCondition} name="toTimeCondition" onChange={this.handleOnChange.bind(this)} >
                                                    <option value="0">Equal to</option>
                                                    <option value="1">Greater than</option>
                                                    <option value="2">Less than</option>
                                                </select>
                                            </div>
                                            <DateTime closeOnSelect inputProps={{readOnly: true}} initialValue={toTime} dateFormat={false} timeFormat="HH:mm" onChange={(e) => this.changeDate(e, 'toTime')}/>
                                        </div>
                                        <div className="form-group">
                                            <span className="filterLbl">Job Type</span>
                                            <select className="form-control filterDD" name="jobType" value={this.state.jobType} onChange={this.handleOnChange.bind(this)} >
                                                <option value="0">Select Job Type</option>
                                                <option value="Type 1">Type 1</option>
                                                <option value="Type 2">Type 2</option>
                                                <option value="NULL">NULL</option>
                                                <option value="CTC">CTC</option>
                                                <option value="ETC">ETC</option>
                                                <option value="ERC">ERC</option>
                                                <option value="COB">COB</option>
                                                <option value="PHYS">PHYS</option>
                                                <option value="QUA">QUA</option>
                                                <option value="CRC">CRC</option>
                                                <option value="TTC">TTC</option>
                                            </select>
                                        </div>                                     
                                        <div className="form-group">
                                            <span className="filterLbl">Job Class</span>
                                            <select className="form-control filterDD" name="jobClass" value={this.state.jobClass} onChange={this.handleOnChange.bind(this)} >
                                                <option value="NA">Select Job Class</option>
                                                <option value="Engineer">Engineer</option>
                                                <option value="Conductor">Conductor</option>
                                                <option value="A/C">Assistant Conductor</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <span className="filterLbl">Location From</span>
                                            <select className="form-control filterDD" name="fromLocation" value={this.state.fromLocation} onChange={this.handleOnChange.bind(this)} >
                                                <option value="-">Select Location</option>
                                                {
                                                    this.renderLocations()
                                                }
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <span className="filterLbl">Location To</span>
                                            <select className="form-control filterDD" name="toLocation" value={this.state.toLocation} onChange={this.handleOnChange.bind(this)} >
                                                <option value="-">Select Location</option>
                                                {
                                                    this.renderLocations()
                                                }
                                            </select>
                                        </div>
                                        <div className={"form-group" + (isFRA ? "" : " hidden")}>
                                            <span className="filterLbl">Deadhead Type</span>
                                            <select className="form-control filterDD" name="deadheadType" value={this.state.deadheadType} onChange={this.handleOnChange.bind(this)} >
                                                <option value="0">Select Dead Type</option>
                                                {
                                                    constants.logTypes.DEADHEAD_TYPE.map((type, key) => <option key={key} value={type.id}>{type.name}</option>)
                                                }
                                            </select>
                                        </div>    
                                        <div className={"form-group" + (isFRA ? "" : " hidden")}>
                                            <span className="filterLbl">Activity Name</span>
                                            <select className="form-control filterDD" name="activityName" value={this.state.activityName} onChange={this.handleOnChange.bind(this)} >
                                                <option value="0">Select Activity Name</option>
                                                {
                                                    this.renderActivities()
                                                }
                                            </select>
                                        </div>    
                                    </div>
                                    <div className="filterActions">
                                            <button className="btn btn-primary">Search</button>
                                            <button type="button" className="btn btn-primary" onClick={this.clearFilter.bind(this)}>Reset</button>
                                        </div>
                                </div>
                            </div>
                        </div>
                        </form>
                </SlidingPane>
                    </div>
                );
        } else {
            return (<div></div>);
        }   
    }
}
// redux connect
function mapStateToProps(state) {
    
    return { 
        filterState:state.filter,
        authDetails:state.authState,
        locations:state.workdays.locations,
        filteractivities : state.workdays.filteractivities
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        submitFilterAction: filterAction,
        resetFilter:resetFilterAction
      },
      dispatch
    );
  }

export default connect(mapStateToProps, mapDispatchToProps)(Filters);